export default "__VITE_ASSET__kGaAsOvh__"